import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../shared/api.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { EbiService } from '../../../shared/ebi.service';
import { AuthenticationService } from '../../../shared/authentication.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-org-details',
  templateUrl: './org-details.component.html',
  styleUrls: ['./org-details.component.css']
})
export class OrgDetailsComponent implements OnInit, OnDestroy {

  org;
  orgId;
  userData;
  userRole;
  uid;
  idToken;
  authStateSubscription: Subscription;
  loaded = false;
  hiddenTests = [];
  testTypes: Array<any> = [
    {name: 'Bacteria', value: 'bacteria'},
    {name: 'Bacteria 100', value: 'bacteria-100'},
    {name: 'C19', value: 'c19'},
    {name: 'E.Coli', value: 'ecoli'},
    {name: 'Lead', value: 'lead'},
    {name: 'Legionella', value: 'legionella'}, 
    {name: 'Free Chlorine', value: 'chlorine'},
    {name: 'H2O2', value: 'h2o2'}
  ];
  form: FormGroup;
  isEditingOrgName = false;

  constructor(private route: ActivatedRoute, private apiService: ApiService, private router: Router,
              private angularFireAuth: AngularFireAuth, private ebiService: EbiService,
              private authenticationService: AuthenticationService, private fb: FormBuilder) {
    this.org = this.router.getCurrentNavigation().extras?.state?.org;

  }

  ngOnInit(): void {

    this.authStateSubscription = this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        this.userData = this.authenticationService.userData;
        this.userRole = this.authenticationService.userRole;
        this.uid = this.userData.uid;
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        if (!this.org) {
          this.orgId = this.route.snapshot.paramMap.get('id');
          this.org = await this.apiService.getOrgData(this.idToken, this.orgId);
          if (!this.org) {
            await this.router.navigate(['/organizations']);
          }
        }
        if (!this.org.numberOfUsers || !this.org.users) {
          await this.getOrgUsers();
        }
        if (this.org.hiddenTests) {
          this.hiddenTests = this.org.hiddenTests;
        }
        console.log(this.org.users);
        this.form = this.fb.group({
          checkArray: this.fb.array(this.org?.enabledTests || [])
        });


        this.loaded = true;

      } else {
        await this.router.navigate(['/']);
      }
    });
  }

  ngOnDestroy() {
    if (this.authStateSubscription) {
      this.authStateSubscription.unsubscribe();
    }
  }

  private async getOrgUsers() {
    const orgUsers = await this.apiService.getOrgUsers(this.idToken, this.org.id);
    this.org.numberOfUsers = orgUsers.length;
    this.org.users = orgUsers;

  }


  async editOrgActivation(org) {
    const active = !org.active;
    org.active = active;
    const data = {
      active
    };
    await this.apiService.updateOrgData(this.idToken, org.id, data);
  }

  async onCheckboxChange(e) {
    const checkArray: FormArray = this.form.get('checkArray') as FormArray;

    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: FormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }

    console.log(checkArray.value);
    await this.apiService.updateOrgData(this.idToken, this.orgId, {enabledTests: checkArray.value});
  }

  async hideTestType(value) {
    if (!this.hiddenTests.includes(value)) {
      this.hiddenTests.push(value);
    } else {
      const index = this.hiddenTests.indexOf(value);
      if (index > -1) {
        this.hiddenTests.splice(index, 1);
      }
    }
    await this.apiService.updateOrgData(this.idToken, this.orgId, {hiddenTests: this.hiddenTests});
  }

  enableOrgEdit() {
    this.isEditingOrgName = true;
    setTimeout(() => {
      document.getElementById('orgNameInput').focus();
    }, 0);


  }

  async editOrgName($event) {
    await this.apiService.updateOrgData(this.idToken, this.orgId, {name: $event.target.value});
    this.org.name = $event.target.value;
    this.isEditingOrgName = false;

  }

  async navigateToUser(user) {
    await this.router.navigate(['/user/', user.userRecord?.uid], {state: user.userData});

  }
}
